import React, { useState, useRef, useEffect } from "react";
import * as Styled from "./styles.js";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { TextField } from "../MuiTextField/index.js";

const ValueCounter = ({ value, title, disabled, handleChange = () => {} }) => {
  const [counter, setCounter] = useState(value);
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    setCounter(value);
  }, [value]);

  useEffect(() => {
    saveCounterValue();
  }, [counter]);

  const handleIncrement = () => {
    setCounter((prevValue) => Math.min(prevValue + 1, 100));
  };

  const handleDecrement = () => {
    setCounter((prevValue) => Math.max(prevValue - 1, 0));
  };

  const startIncrement = () => {
    handleIncrement();
    timeoutRef.current = setTimeout(() => {
      intervalRef.current = setInterval(handleIncrement, 100);
    }, 200);
  };

  const startDecrement = () => {
    handleDecrement();
    timeoutRef.current = setTimeout(() => {
      intervalRef.current = setInterval(handleDecrement, 100);
    }, 200);
  };

  const stopChange = () => {
    clearInterval(intervalRef.current);
    clearTimeout(timeoutRef.current);
  };

  const saveCounterValue = () => {
    handleChange(title?.toLowerCase(), counter);
  };

  return (
    <Styled.MainDiv>
      <Styled.TitleDisplay>{title}</Styled.TitleDisplay>
      <Styled.Container width="85px">
        <TextField
          value={counter}
          disabled={disabled}
          onChange={(e) => {
            if (disabled) return;
            const value = e.target.value;

            // Allow only numeric input
            if (/^\d*$/.test(value)) {
              const numericValue = Math.min(Math.max(Number(value), 0), 100); // Clamp value between 0 and 100
              setCounter(numericValue);
            }
          }}
          onBlur={() => {
            if (disabled) return;
            if (isNaN(counter) || counter < 0 || counter > 100) {
              setCounter(Math.min(Math.max(value, 0), 100)); // Reset to a valid value
            }
            saveCounterValue();
          }}
          min={0}
          max={100}
          sx={{
            "& fieldset": { border: "none" },  
          }}
          fieldStyling={{
            "& .MuiInputBase-root": {
              outline: "none",
              backgroundColor: "#ffffff",
              fontFamily: "DM Sans",
              fontSize: "12px",
              fontWeight: 400,
              color: "#565556",
              height: "40px",
              borderRadius: "5px",
              "&:focus": {
                border: "none",
                outline: "none",
              },
              "&::before, &::after": {
                display: "none",
              },
            },
          }}
        />
        <Styled.IconsContainer>
          <Styled.IncrementButton
            onMouseDown={startIncrement}
            onMouseUp={stopChange}
            onMouseLeave={stopChange}
            onTouchStart={startIncrement}
            onTouchEnd={stopChange}
            // onBlur={saveCounterValue}
            // tabIndex={0}
            disabled={disabled}
          >
            <ArrowDropUpIcon style={{ color: "white" }} />
          </Styled.IncrementButton>
          <Styled.DecrementButton
            onMouseDown={startDecrement}
            onMouseUp={stopChange}
            onMouseLeave={stopChange}
            onTouchStart={startDecrement}
            onTouchEnd={stopChange}
            // onBlur={saveCounterValue}
            // tabIndex={0}
            disabled={disabled}
          >
            <ArrowDropDownIcon style={{ color: "white" }} />
          </Styled.DecrementButton>
        </Styled.IconsContainer>
      </Styled.Container>
    </Styled.MainDiv>
  );
};

export default ValueCounter;
